export const dropdownButtonCss = ({ className, overrideCss, disabled, truncateLongValues, }) => {
    const dropdownBlock = [];
    const dropdownButtonArea = [];
    const dropdownButtonWrapper = [];
    const dropdownDivider = [];
    const dropdownListArea = [];
    const dropdownListItem = [];
    const dropdownArrowArea = [];
    const dropdownArrow = [];
    if (!overrideCss) {
        dropdownBlock.push('dropdown-button');
        dropdownButtonArea.push('dropdown-button__button-area');
        dropdownButtonWrapper.push('dropdown-button__button-wrapper');
        dropdownDivider.push('dropdown-button__divider');
        dropdownListArea.push('dropdown-button__list-area');
        dropdownListItem.push('dropdown-button__list-item');
        dropdownArrowArea.push('dropdown-button__arrow-area');
        dropdownArrow.push('dropdown-button__arrow');
        if (disabled) {
            dropdownBlock.push('dropdown-button--disabled');
            dropdownButtonArea.push('dropdown-button__button-area--disabled');
            dropdownArrowArea.push('dropdown-button__arrow-area--disabled');
            dropdownArrow.push('dropdown-button__arrow--disabled');
        }
        if (truncateLongValues) {
            dropdownListItem.push('dropdown-button__list-item--truncate');
        }
    }
    if (className) {
        dropdownBlock.push(className);
        dropdownButtonArea.push(`${className}__button-area`);
        dropdownButtonWrapper.push(`${className}__button-wrapper`);
        dropdownDivider.push(`${className}__divider`);
        dropdownListArea.push(`${className}__list-area`);
        dropdownListItem.push(`${className}__list-item`);
        dropdownArrowArea.push(`${className}__arrow-area`);
        dropdownArrow.push(`${className}__arrow`);
        if (disabled) {
            dropdownBlock.push(`${className}--disabled`);
            dropdownButtonArea.push(`${className}__button-area--disabled`);
            dropdownArrowArea.push(`${className}__arrow-area--disabled`);
            dropdownArrow.push(`${className}__arrow--disabled`);
        }
        if (truncateLongValues) {
            dropdownListItem.push(`${className}__list-item--truncate`);
        }
    }
    return {
        dropdownBlock: dropdownBlock.join(' '),
        dropdownButtonArea: dropdownButtonArea.join(' '),
        dropdownButtonWrapper: dropdownButtonWrapper.join(' '),
        dropdownDivider: dropdownDivider.join(' '),
        dropdownListArea: dropdownListArea.join(' '),
        dropdownListItem: dropdownListItem.join(' '),
        dropdownArrowArea: dropdownArrowArea.join(' '),
        dropdownArrow: dropdownArrow.join(' '),
    };
};
//# sourceMappingURL=dropdownButtonCss.js.map